import { QueryFunctionContext } from "@tanstack/react-query";
import { DeliveryNoteDetailsModel } from "./Models";
import ApiHttpClient from "@/HttpClient";

export const fetchDeliveryNoteWithDetails = async ({ queryKey }: QueryFunctionContext) => {
  const [, deliveryNoteId] = queryKey;

  const { data, status, statusText } = await ApiHttpClient().get<DeliveryNoteDetailsModel>(`deliveryNote/${deliveryNoteId}`);

  if (!data) throw new Error(`Did not receive a response, status ${status} ${statusText}`);
  return data;
}